import { Component, EventEmitter, forwardRef, Input, OnInit, Output } from '@angular/core';
import {
    AbstractControl,
    ControlContainer,
    ControlValueAccessor,
    FormGroupDirective,
    NG_VALUE_ACCESSOR,
} from '@angular/forms';

@Component({
    selector: 'roblex-calculator-input',
    templateUrl: './calculator-input.component.html',
    styleUrls: ['./calculator-input.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            multi: true,
            useExisting: forwardRef(() => CalculatorInputComponent),
        },
    ],
})
export class CalculatorInputComponent implements OnInit, ControlValueAccessor {
    /**
     * Input form control name of input form field component
     */
    @Input() formControlName: string;
    /**
     * Input label of input field component
     */
    @Input() label = 'input form field label';
    /**
     * Input disabled of input field component
     */
    @Input() disabled: boolean = false;
    /**
     * Input currency name of calculator input component
     */
    @Input() currencyName: string;
    /**
     * Output keyup of calculator input component
     */
    @Output() valueChange: EventEmitter<any> = new EventEmitter();
    /**
     * Control  of input form field component
     */
    control: AbstractControl;
    /**
     * Timeout  of calculator input component
     */
    timeout: any;
    /**
     * Interval  of calculator input component
     */
    interval = 500;
    /**
     * Value  of input field component
     */
    _value = '';
    /**
     * Gets value
     */
    get value() {
        return this._value;
    }
    /**
     * Sets value
     */
    set value(val) {
        this._value = val;
        this.onChangeCallback(this._value);
    }
    /**
     * Gets form
     */
    get form() {
        return this.controlContainer?.formDirective
            ? (this.controlContainer?.formDirective as FormGroupDirective)?.form
            : null;
    }
    /**
     * Determines whether touched callback on
     */
    onTouchedCallback: () => void;
    /**
     * Propagate change of input field component
     */
    onChangeCallback = (_: any) => {};
    /**
     * Creates an instance of calculator input component.
     * @param controlContainer ControlContainer
     */
    constructor(public controlContainer: ControlContainer) {}
    /**
     * on init
     */
    ngOnInit(): void {
        this.control = this.form.get(this.formControlName);
    }
    /**
     * Determines whether keyup send on
     * @param event any
     */
    onKeyupEvent(value: string): void {
        clearTimeout(this.timeout);
        const newValue = +(value.replace(new RegExp(',', 'g'), ''));
        this.timeout = setTimeout(() => {
            if (newValue > 0) {
                this.writeValue(newValue);
                this.valueChange.emit(newValue);
            }
            clearTimeout(this.timeout);
        }, this.interval);
        // this.showOperations(OperationActive.S);
    }
    /**
     * Writes value
     * @param value any
     */
    writeValue(value: any): void {
        this.value = value;
        this.onChangeCallback(this.value);
    }
    /**
     * Registers on change
     * @param fn any
     */
    registerOnChange(fn: any): void {
        this.onChangeCallback = fn;
    }
    /**
     * Registers on touched
     * @param fn any
     */
    registerOnTouched(fn: any): void {
        this.onTouchedCallback = fn;
    }
    /**
     * Sets disabled state
     * @param isDisabled boolean
     */
    setDisabledState?(isDisabled: boolean): void {
        this.disabled = isDisabled;
    }
}
